
import { computed, defineComponent, onMounted, onUpdated, watch } from 'vue'

const __default__ = defineComponent({
  name: 'DfSlider',
  emits: ['update:modelValue', 'validated'],
  props: {
    modelValue: {
      type: Number,
      required: true
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      required: true
    },
    innerMin: {
      type: Number,
      default: 0
    },
    autoMinMax: {
      type: Boolean
    }
  },
  setup (props, { emit }) {
    const inputValue = computed({
      get: () => props.modelValue,
      set: (value: number) => {
        const num = parseInt(value as any)
        emit('update:modelValue', Math.min(props.max, Math.max(props.min, isNaN(num) ? 0 : num)))
      },
    })

    const sliderBorderRadius = computed(() => props.innerMin > 0 ? '0' : '20px')

    const isValid = computed(() => {
      const value = parseInt(inputValue.value as any)
      return value <= props.max && (props.innerMin ? value >= props.innerMin : value >= props.min)
    })

    const sliderInnerWidth = computed(() => document.querySelector<HTMLElement>('.q-slider__inner'))
    const inputElement = computed(() => document.querySelector<HTMLElement>('.input'))

    const updateInputFieldPosition = () => {
      const sliderWidth = sliderInnerWidth.value?.offsetWidth
      if (!sliderWidth) return
      const offset = 20 // half size of input field
      const thumbPosition = (inputValue.value / (props.max - props.innerMin) * sliderWidth) - offset
      const innerMinOffset = (props.innerMin / (props.max - props.innerMin) * sliderWidth) - offset
      const finalPosition = () => thumbPosition >= sliderWidth + innerMinOffset ? sliderWidth + innerMinOffset : thumbPosition <= innerMinOffset ? innerMinOffset : thumbPosition
      inputElement.value?.setAttribute('style', `left: ${finalPosition()}px`)
    }

    watch(isValid, (isValid, oldValue) => {
      emit('validated', isValid)
    })

    onMounted(() => {
      updateInputFieldPosition()
      emit('update:modelValue', inputValue.value)
      emit('validated', isValid)
    })

    onUpdated(() => {
      updateInputFieldPosition()
    })

    return {
      inputValue,
      isValid,
      sliderBorderRadius,
    }
  }
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "150b5548": (_ctx.sliderBorderRadius)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__